import { GridColDef } from "@mui/x-data-grid";
import { formatDateToGermanDate } from "../../utils/helper";

/**
 * Column definitions for the assigned tasks data grid.
 * Defines the structure and behavior of columns in the tasks list table.
 * 
 * @type {GridColDef[]}
 * 
 * @property {string} client_name - Customer/client name column
 * @property {string} created_by - Task creator column
 * @property {string} building_name - Building name column 
 * @property {string} plant_name - Plant name column
 * @property {string} sub_task_type - Task type column
 * @property {string} due_date - Due date column with German date formatting
 * @property {string} status - Task status column
 */
export const columns: GridColDef[] = [
  {
    field: "client_name",
    headerName: "Kunde",
    flex: 1,
  },
  {
    field: "created_by",
    headerName: "Aufgabenersteller",
    flex: 1,
  },
  {
    field: "building_name",
    headerName: "Gebäude",
    flex: 1,
  },
  {
    field: "plant_name",
    headerName: "Anlage",
    flex: 1,
  },
  {
    field: "sub_task_type",
    headerName: "Aufgabenart",
    flex: 1,
  },
  {
    field: "due_date",
    headerName: "Enddatum",
    flex: 1,
    valueGetter: ({ row, value }) => {
      return value ? formatDateToGermanDate(new Date(value)) : '-';
    },
  },
  {
    field: "status",
    headerName: "Status",
    flex: 1,
  },
];
